import { event } from "vue-gtag";

function trackEventWithCallbackAndFallback(
  event_name,
  eventData,
  callback,
  fallbackTime = 1000
) {
  let callbackCalled = false;

  if (import.meta.env.VITE_ENV !== "production") {
    callback();
    return;
  }

  const callbackWrapper = async () => {
    if (!callbackCalled) {
      callbackCalled = true;
      await callback();
    }
  };

  eventData.event_callback = callbackWrapper;

  // Try to send the event to Google Analytics
  event(event_name, eventData);

  // Set a fallback to execute the callback after a timeout
  setTimeout(() => {
    callbackWrapper();
  }, fallbackTime);
}

export { trackEventWithCallbackAndFallback };
